import { CreateReturnIconButton } from '../../return/create-return/create-return-icon-button';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { NavigationPanel } from '../navigation-panel/navigation-panel';
import { messages } from './messages';
import { EnhancedReturnsPanelButton } from './enhanced-returns-panel-button';
import { ReturnsPanelButton } from './returns-panel-button';
import { useReturnsPanelContext } from './returns-panel-context-provider';
import { useEnhancedReturnsContext } from '../../context/enhanced-returns-context-provider';

export const ReturnsPanel = () => {
  return (
    <NavigationPanel headerActionButton={<CreateReturnIconButton />} headerMessageDescriptor={messages.returnsPanelHeader}>
      <ReturnsPanelItems />
    </NavigationPanel>
  );
};

const ReturnsPanelItems = () => {
  const { loading } = useEnhancedReturnsContext();
  const { enhancedReturns, standardReturns } = useReturnsPanelContext();

  if (loading) {
    return <LoadingIndicator />;
  }

  return (
    <>
      <EnhancedReturnsPanelItems returns={enhancedReturns} />
      <LegacyReturnsPanelItems returns={standardReturns} />
    </>
  );
};

const LegacyReturnsPanelItems = ({ returns }) =>
  returns.map(({ counter, returnFulfillmentId, isNewReturn }) => {
    return (
      <ReturnsPanelButton key={returnFulfillmentId} counter={counter} isNewReturn={isNewReturn} returnFulfillmentId={returnFulfillmentId} />
    );
  });

const EnhancedReturnsPanelItems = ({ returns }) =>
  returns.map(({ id, name, status }) => {
    return <EnhancedReturnsPanelButton key={id} name={name} returnRequestId={id} status={status} />;
  });
